<style scope>
</style>

<template>
  <div>

    <b-table :data="lista" :loading="loading" class="row-click"
               :paginated="true" :perPage="20" detailed :default-sort-direction="'desc'"
                default-sort="DT_EMISSAO">
        <portal-lista-vazia slot="empty"/>

        <template slot-scope="props">

          <b-table-column label="Código Web">
            {{ props.row.CODIGOWEB }}
          </b-table-column>

          <b-table-column label="Cliente Código">
            {{ props.row.COD_CLIENTE }}
          </b-table-column>

          <b-table-column label="Cliente CNPJ">
            {{ props.row.CNPJ | cpfcnpj }}
          </b-table-column>

          <b-table-column label="Cliente Nome">
          {{ (props.row.cliente && props.row.cliente.A1_NREDUZ) ? props.row.cliente.A1_NREDUZ : props.row.cliente.A1_NOME }}
          </b-table-column>

          <b-table-column label="Data Emissão" field="DT_EMISSAO" sortable>
            {{ props.row.DT_EMISSAO | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Data Entrega" :visible="false">
            {{ props.row.DT_ENTREGA | moment("DD/MM/YYYY") }}
          </b-table-column>

          <b-table-column label="Total">
            {{ props.row.VALOR | moeda }}
          </b-table-column>

          <b-table-column label="Descontos" >
            <b-tag>{{props.row.DESC1}}%</b-tag>
            <b-tag>{{props.row.DESC2}}%</b-tag>
            <b-tag>{{props.row.DESC4}}%</b-tag>
          </b-table-column>

          <b-table-column label="Status" >
            <b-tag type="is-info" v-if="props.row.STATUS === 'E'">Convertido</b-tag>
            <b-tag type="is-danger" v-if="props.row.STATUS === 'V'">Vencido</b-tag>
            <b-tag type="is-success" v-if="props.row.STATUS === 'A'">Salvo</b-tag>            
          </b-table-column>

          <b-table-column label="Download" :visible="true">
            <button class="button is-small" @click="downloadOrcamentoClienteBase(props.row.CODIGOWEB)"
                    title="Download">
                <b-icon icon="file-pdf"/>
            </button>
          </b-table-column> 

          <b-table-column label="Editar">            
            <b-tooltip label="Editar Orçamento">
              <button class="button is-small is-info" @click="editarOrcamento(props.row.CODIGOWEB)" v-if="props.row.CONVERTIDO !== 'S' && props.row.STATUS !== 'V'">
                <b-icon icon="pencil"/>
              </button>
            </b-tooltip>
          </b-table-column>

        </template>

        <template slot="detail" slot-scope="props">
          <table class="table is-fullwidth m-t-sm" v-if="props.row.itens.length > 0">
            <tr>
              <th>Item</th>
              <th>Código</th>
              <th>Descrição</th>
              <th>Qtd</th>
              <th>Valor tabela</th>
              <th>Valor venda</th>
              <th>Desconto(%)</th>
              <th>Comissão(%)</th>
              <th>Total do Item</th>
            </tr>
            <tr v-for="(item,index) in props.row.itens" :key="index">
              <td>{{ item.NUMITEM }}</td>
              <td>{{ item.COD_ITEM }}</td>
              <td>{{ item.DESCRICAO }}</td>
              <td>{{ item.QUANT }}</td>
              <td>{{ item.VALOR_TABELA | moeda}}</td>
              <td>{{ item.VALOR_VENDA | moeda}}</td>
              <td class="is-numeric">
                {{item.DESCONTO }}%
              </td>
              <td class="is-numeric">
                {{ item.COMISSAO_ITEM }}%
              </td>
              <td>{{ item.VALOR_TOTAL | moeda }}</td>
            </tr>
          </table>
        </template>

      </b-table>

  </div>
</template>

<script>
  export default {
    props: ['lista', 'loading', 'parametros'],
    methods: {
      created () {
        this.dataEntregaVisivel = false
      },
      data () {
        return {
          dataEntregaVisivel: false
        }
      },
      downloadOrcamentoClienteBase (codWeb) {
        this.isLoading = true
        this.$http({
          method: 'get',
          url: this.$URL.DOWNLOAD.ORCAMENTO_CLIENTE_BASE + codWeb,
          responseType: 'arraybuffer'
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'ORCAMENTO_CLIENTE_BASE_' + codWeb + '.pdf')
            document.body.appendChild(link)
            link.click()
            this.isLoading = false
          })
          .catch((response) => {
            this.$toast.open({
              message: 'Não foi possível localizar o orçamento para download.',
              type: 'is-danger',
              duration: 4 * 1000
            })
            this.isLoading = false
          })
      },
      editarOrcamento (codigo) {
        this.$router.push('/orcamento/cliente/edit/' + codigo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/orcamento/ListaCliente.vue